import { useState } from "react"

import type { Instruction } from "@/graphql/codegen/graphql"
import type { InstructionDialogs } from "@/screens/ManageProducts/components/Instructions/types"

interface UseInstructionModalReturn {
  dialogOpen: InstructionDialogs | null
  selectedInstruction: Instruction | null
  setSelectedInstruction: (instruction: Instruction | null) => void
  setDialogOpen: (dialog: InstructionDialogs | null) => void
}

export const useInstructionDialog = (): UseInstructionModalReturn => {
  const [selectedInstruction, setSelectedInstruction] = useState<Instruction | null>(null)
  const [dialogOpen, setDialogOpen] = useState<InstructionDialogs | null>(null)

  return {
    selectedInstruction,
    dialogOpen,
    setSelectedInstruction,
    setDialogOpen,
  }
}
